import { z } from 'zod';
import { getDefaults } from '@mews/framework';
import { FinancialDocumentPdfTemplateType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export const sendReminderSchema = z.object({
    templateType: z.nativeEnum(FinancialDocumentPdfTemplateType),
    printLanguageCode: z.string(),
    emails: z
        .array(z.string().email())
        .min(1, { message: TextKey.SendReminderRecipientsEmptyErrorMessage })
        .refine((arr) => arr.every((email) => z.string().email().safeParse(email).success), {
            message: TextKey.SendReminderRecipientsInvalidGenericEmailErrorMessage,
        }),
});

export const sendReminderFormDefaultValues = getDefaults(sendReminderSchema) as SendReminderFormValues;
export type SendReminderFormValues = z.infer<typeof sendReminderSchema>;
